import { $apiDelete, $apiGet, $apiPost, $apiPut } from '~/utils/request'
import type { SysUser } from '~/models'

export const GetAll = () => $apiGet<SysUser[]>(`/v1/sysUser/all`)
